import { o as f } from "./base-Cfj0C7wU.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function a(n) {
  return (s, d) => {
    const { slot: e, selector: t } = n != null ? n : {}, i = "slot" + (e ? `[name=${e}]` : ":not([name])");
    return f(s, d, { get() {
      var r, o;
      const l = (r = this.renderRoot) == null ? void 0 : r.querySelector(i), u = (o = l == null ? void 0 : l.assignedElements(n)) != null ? o : [];
      return t === void 0 ? u : u.filter((c) => c.matches(t));
    } });
  };
}
export {
  a as f
};
